import apiClient from '../../../lib/axios';

export const fetchFolderTypes = async ({ page = 1, pageSize = 10, isActive, search } = {}) => {
  const params = new URLSearchParams();
  params.append('page', page);
  params.append('limit', pageSize);
  if (typeof isActive === 'boolean') params.append('isActive', isActive);
  if (search) params.append('search', search);
  const { data } = await apiClient.get(`/api/folder-types?${params.toString()}`);
  return data;
};

export const fetchActiveFolderTypes = async () => {
  const { data } = await apiClient.get('/api/folder-types/active');
  return data;
};

export const fetchFolderTypeById = async (id) => {
  const { data } = await apiClient.get(`/api/folder-types/${id}`);
  return data;
};

export const createFolderType = async (payload) => {
  const { data } = await apiClient.post('/api/folder-types', payload);
  return data;
};

export const updateFolderType = async ({ id, payload }) => {
  const { data } = await apiClient.patch(`/api/folder-types/${id}`, payload);
  return data;
};

export const deleteFolderType = async (id) => {
  const { data } = await apiClient.delete(`/api/folder-types/${id}`);
  return data;
};

export default fetchFolderTypes;
